import {
  SalesforceObjectType,
  SalesforceExeExportObjectType,
  SalesforceTimelineStatusExportObjectType,
} from "./ComponentTypes";

export const defaultSalesforceMapping = {
  [SalesforceObjectType.LEAD.value]: {
    post_code: ["PostalCode"],
    address: ["State", "City", "Street"],
    company: ["Company"],
    // position: ["Title"],
    name: ["LastName", "FirstName"],
    // honorific: ["Salutation"],
    // tel: ["Phone"],
    // fax: ["Fax"],
    // email: ["Email"],
  },
  // [SalesforceObjectType.INDIVIDUAL.value]: {
  //   name: ["LastName", "FirstName"],
  //   honorific: ["Salutation"],
  // },
  // [SalesforceObjectType.ACCOUNT.value]: {
  //   post_code: ["ShippingPostalCode"],
  //   address: ["ShippingState", "ShippingCity", "ShippingStreet"],
  //   tel: ["Phone"],
  //   fax: ["Fax"],
  // },
  [SalesforceObjectType.CONTACT.value]: {
    post_code: ["MailingPostalCode"],
    address: ["MailingState", "MailingCity", "MailingStreet"],
    company: ["Account.Name"],
    // position: ["Title"],
    // branch: ["Department"],
    name: ["LastName", "FirstName"],
    // honorific: ["Salutation"],
    // tel: ["Phone"],
    // fax: ["Fax"],
    // email: ["Email"],
  },
};

export const defaultSalesforceExeExportMapping = {
  [SalesforceExeExportObjectType.CONTACT.value]: {
    [SalesforceExeExportObjectType.ACCOUNT.value]: {
      company_name: "Name",
      post_code: "ShippingPostalCode",
      prefecture_name: "ShippingState",
      city_name: "ShippingCity",
      street_number: "ShippingStreet",
      tel: "Phone",
    },
    [SalesforceExeExportObjectType.CONTACT.value]: {
      position: "Title",
      //name: "LastName",
      first_name: "FirstName",
      last_name: "LastName",
    },
  },
  [SalesforceExeExportObjectType.LEAD.value]: {
    [SalesforceExeExportObjectType.LEAD.value]: {
      company_name: "Company",
      post_code: "PostalCode",
      prefecture_name: "State",
      city_name: "City",
      street_number: "Street",
      tel: "Phone",
      position: "Title",
      first_name: "FirstName",
      last_name: "LastName",
      //name: "LastName",
    }
  },
};

export const defaultSalesforceTimelineStatusExportMapping = {
  [SalesforceTimelineStatusExportObjectType.EVENT.value]: {
    [SalesforceTimelineStatusExportObjectType.EVENT.value]: {
      subject: "Subject",
      activity_date_time: "ActivityDateTime",
      description: "Description",
    }
  },
};



// WEBPACK FOOTER //
// ./src/constants/SalesforceMapping.js